import { render, staticRenderFns } from "./lotto-review.vue?vue&type=template&id=644b4de7"
import script from "./lotto-review.vue?vue&type=script&lang=js"
export * from "./lotto-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644b4de7')) {
      api.createRecord('644b4de7', component.options)
    } else {
      api.reload('644b4de7', component.options)
    }
    module.hot.accept("./lotto-review.vue?vue&type=template&id=644b4de7", function () {
      api.rerender('644b4de7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/lotto-review.vue"
export default component.exports